import { render, staticRenderFns } from "./CulvertInspectionsTable.vue?vue&type=template&id=c822b5e6&scoped=true"
import script from "./CulvertInspectionsTable.vue?vue&type=script&lang=ts"
export * from "./CulvertInspectionsTable.vue?vue&type=script&lang=ts"
import style0 from "./CulvertInspectionsTable.vue?vue&type=style&index=0&id=c822b5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c822b5e6",
  null
  
)

export default component.exports